<template>
<div class="">
    <!--<b><span class="mb-4">Productos seleccionados: {{this.$store.state.store_carrito.length}}</span></b>
    <p>Total a pagar: S/ {{totalPagar}}</p>
    -->
    <b>Resumen de compra</b>
    <table class="table">
      <tbody>
        <tr>
          <td>Productos seleccionados</td>
          <td>{{doneTodos.length}}</td>
        </tr>
        <tr>
          <td>Importe a pagar</td>
          <td><span class="text-primary">S/ {{totalPagar}}</span></td>
        </tr>
      </tbody>
    </table>


    <b v-if="doneTodos.length>0">Detalle</b>

    <table v-if="doneTodos.length>0" class="table mt-4">
        <thead>
            <tr>
                <th scope="col">Item</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Importe</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in doneTodos" :key="index">
                <td>{{item.descripcionPlanta}}</td>
                <td>{{item.cantidad}}</td>
                <td>S/ {{item.total.toFixed(2)}}</td>
            </tr>
        </tbody>
    </table>

    <el-alert v-else title="Su carrito se encuentra vacío" type="warning"></el-alert>

</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        items: {
            type: Array,
            required: true,
            default: []
        }
    },
    computed: {
      ...mapGetters(['doneTodos', 'totalPagar'])
        /*productos() {
            //return this.$store.state.store_carrito
            return CircularJSON.stringify(this.$store.getters.doneTodos)
        }*/
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/plantitas/Resumen.vue